import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {AuctionEvent} from '../domain/auction-event/auction-event';

@Injectable({
  providedIn: 'root'
})
export abstract class ItemSummaryEventService {

  data = {
    rbAuctionEvents: Array<AuctionEvent>()
  };

  rbAuctionEventListCallback: Subject<AuctionEvent[]> = new Subject<AuctionEvent[]>();
  auctionEventCallback: Subject<AuctionEvent> = new Subject<AuctionEvent>();

  protected constructor() {}

  abstract getRbAuctionEvents(days: number): void;
  abstract getAuctionEventDetails(eventId: number): void;
  abstract getAuctionEventDetailsObservable(auctionEventId: number): Observable<any>;
}
